import { Meal } from "@/clients/models/Meal";
import { CircleNotchIcon } from "@/components/icons/circle-notch-icon";
import { PlusIcon } from "@/components/icons/plus-icon";
import { TextButton } from "@/components/ui/buttons/TextButton";
import { FoodLibraryList } from "@/features/meal-plan/components/food-library-list";
import { SavedMealsTabValue } from "@/features/meal-plan/constants/saved-meals-tabs";
import { memo } from "react";

interface SavedFoodsPickerListProps {
  mode: SavedMealsTabValue;
  addingMealId: string | null;
  onAddClick: (meal: Meal) => void;
}

export const SavedFoodsPickerList = memo(function SavedFoodsPickerList({
  mode,
  addingMealId,
  onAddClick,
}: SavedFoodsPickerListProps) {
  return (
    <FoodLibraryList
      tab={mode}
      renderMealAction={(meal) => {
        const mealName = meal.name ?? "";
        const isAdding = Boolean(meal.id) && addingMealId === meal.id;

        return (
          <TextButton
            type="button"
            aria-label={`Add ${mealName || "meal"} to extra food`}
            disabled={isAdding}
            onClick={() => onAddClick(meal)}
            className="flex h-10 w-10 shrink-0 items-center justify-center"
          >
            {isAdding ? (
              <CircleNotchIcon className="fill-os-brand h-4 w-4 animate-spin" />
            ) : (
              <PlusIcon className="fill-os-brand border-os-brand h-5 w-5 rounded-full border p-1" />
            )}
          </TextButton>
        );
      }}
    />
  );
});
